// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main container */
.website-design-container {
  display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 90px;
    background-color:#fff;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    gap: 20px;
}

/* Left Section - Image */
.website-design-image {
  position: relative;
  width: 35%;
  order: 1; /* Place image on the left */
  margin-top: 50px;
}

.services-image {
  width: 100%;
  height: auto;
  border-radius: 8px;
  padding: 10px 0;
 
}

/* Right Section - Content */
.website-design-text {
  width: 60%;
  order: 2; /* Place content on the right */
  margin-top: -50px;
}

.website-design-text h1 {
  font-size: 2em;
  color: #000;
  margin-bottom: -5px;
}
.website-design-text h2 {
  font-size: 1rem;
  color: #555;
  margin-bottom: 10px;
}
.website-design-text p {
  font-size: 0rem;
  color: #555;
  margin-bottom: 20px;
}

.services-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  list-style: none;
  padding: 0;
}

.services-list li {
  width: 45%;
  font-size: 0.9em;
  color: #333;
}

/* Button */
.website-design-button {
  background-color: #00c853;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 1em;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 20px;
  transition: background-color 0.3s ease;
}

.website-design-button:hover {
  background-color: #009624;
}

/* Responsive Design */
@media (max-width: 768px) {
  .website-design-container {
    flex-direction: column; /* Stack items vertically */
    align-items: center; /* Center items in the column */
    padding: 20px; /* Adjust padding for smaller screens */
    gap: 10px; /* Reduce gap between sections */
  }

  .website-design-image {
    width: 88%; /* Full width image */
    height:20%;
    padding-top:80px; /* Remove extra margin */
  }

  .website-design-text {
    width: 100%; /* Full width content */
    text-align: left; /* Center-align text for better mobile readability */
    margin-top: -10px; /* Add spacing between image and text */
    margin-bottom: 20px;
  }

  .website-design-text h1 {
    font-size: 2.0em; /* Adjust font size */
  }

  .website-design-text h2 {
    font-size: 1em; /* Adjust font size */
  }

  .website-design-text p {
    font-size: 0.9em; /* Adjust font size */
  }

  .website-design-button {
    width: 100%; /* Full width button */
  }
}




@media (min-width: 1380px) and (max-width: 1919px) {
  .website-design-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 80px; /* Reduced padding for smaller screens */
    padding-top:150px;
  }

  .website-design-image {
    width: 32%; /* Adjusted image size */
    margin-top: 20px;
  }

  .website-design-text {
    width: 62%; /* Adjusted content width */
    margin-top: -100px;
  }

  .website-design-text h1 {
    font-size: 2em; /* Medium heading size */
  }

  .website-design-text h2 {
    font-size: 1rem;
  }

  .website-design-text p {
    font-size: 1rem;
  }

  .services-list li {
    width: 45%; /* Adjust spacing */
  }

  .website-design-button {
    font-size: 1em; /* Default button size */
    padding: 10px 20px;
  }
}
/* Styles for Large Screens (1920px and Above) */
@media (min-width: 1920px) {
  .website-design-container {
    max-width: 1600px;
    margin: 0 auto; /* Center the container */
    padding: 100px; /* Increased padding for larger screens */
  }

  .website-design-image {
    width: 40%; /* Slightly larger image */
    margin-top: 0; /* Adjust top margin */
  }

  .website-design-text {
    width: 55%; /* Adjusted content width */
    margin-top: 0; /* Align content vertically */
  }

  .website-design-text h1 {
    font-size: 2.5em; /* Larger heading for desktops */
  }

  .website-design-text h2 {
    font-size: 1.2em; /* Larger subheading */
  }

  .website-design-text p {
    font-size: 1.1rem; /* Larger paragraph text */
  }

  .services-list li {
    width: 42%; /* Adjust width for better spacing */
  }

  .website-design-button {
    font-size: 1.1em; /* Larger button text */
    padding: 15px 25px; /* Bigger button for emphasis */
  }
}`, "",{"version":3,"sources":["webpack://./src/components/WebsiteDesign/WebsiteDesign.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,aAAa;IACX,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,wCAAwC;IACxC,SAAS;AACb;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ,EAAE,4BAA4B;EACtC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;;AAEjB;;AAEA,4BAA4B;AAC5B;EACE,UAAU;EACV,QAAQ,EAAE,+BAA+B;EACzC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,WAAW;AACb;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB,EAAE,2BAA2B;IACnD,mBAAmB,EAAE,+BAA+B;IACpD,aAAa,EAAE,uCAAuC;IACtD,SAAS,EAAE,gCAAgC;EAC7C;;EAEA;IACE,UAAU,EAAE,qBAAqB;IACjC,UAAU;IACV,gBAAgB,EAAE,wBAAwB;EAC5C;;EAEA;IACE,WAAW,EAAE,uBAAuB;IACpC,gBAAgB,EAAE,oDAAoD;IACtE,iBAAiB,EAAE,uCAAuC;IAC1D,mBAAmB;EACrB;;EAEA;IACE,gBAAgB,EAAE,qBAAqB;EACzC;;EAEA;IACE,cAAc,EAAE,qBAAqB;EACvC;;EAEA;IACE,gBAAgB,EAAE,qBAAqB;EACzC;;EAEA;IACE,WAAW,EAAE,sBAAsB;EACrC;AACF;;;;;AAKA;EACE;IACE,iBAAiB;IACjB,cAAc;IACd,aAAa,EAAE,wCAAwC;IACvD,iBAAiB;EACnB;;EAEA;IACE,UAAU,EAAE,wBAAwB;IACpC,gBAAgB;EAClB;;EAEA;IACE,UAAU,EAAE,2BAA2B;IACvC,kBAAkB;EACpB;;EAEA;IACE,cAAc,EAAE,wBAAwB;EAC1C;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU,EAAE,mBAAmB;EACjC;;EAEA;IACE,cAAc,EAAE,wBAAwB;IACxC,kBAAkB;EACpB;AACF;AACA,gDAAgD;AAChD;EACE;IACE,iBAAiB;IACjB,cAAc,EAAE,yBAAyB;IACzC,cAAc,EAAE,yCAAyC;EAC3D;;EAEA;IACE,UAAU,EAAE,0BAA0B;IACtC,aAAa,EAAE,sBAAsB;EACvC;;EAEA;IACE,UAAU,EAAE,2BAA2B;IACvC,aAAa,EAAE,6BAA6B;EAC9C;;EAEA;IACE,gBAAgB,EAAE,gCAAgC;EACpD;;EAEA;IACE,gBAAgB,EAAE,sBAAsB;EAC1C;;EAEA;IACE,iBAAiB,EAAE,0BAA0B;EAC/C;;EAEA;IACE,UAAU,EAAE,oCAAoC;EAClD;;EAEA;IACE,gBAAgB,EAAE,uBAAuB;IACzC,kBAAkB,EAAE,+BAA+B;EACrD;AACF","sourcesContent":["/* Main container */\n.website-design-container {\n  display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 90px;\n    background-color:#fff;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    gap: 20px;\n}\n\n/* Left Section - Image */\n.website-design-image {\n  position: relative;\n  width: 35%;\n  order: 1; /* Place image on the left */\n  margin-top: 50px;\n}\n\n.services-image {\n  width: 100%;\n  height: auto;\n  border-radius: 8px;\n  padding: 10px 0;\n \n}\n\n/* Right Section - Content */\n.website-design-text {\n  width: 60%;\n  order: 2; /* Place content on the right */\n  margin-top: -50px;\n}\n\n.website-design-text h1 {\n  font-size: 2em;\n  color: #000;\n  margin-bottom: -5px;\n}\n.website-design-text h2 {\n  font-size: 1rem;\n  color: #555;\n  margin-bottom: 10px;\n}\n.website-design-text p {\n  font-size: 0rem;\n  color: #555;\n  margin-bottom: 20px;\n}\n\n.services-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  list-style: none;\n  padding: 0;\n}\n\n.services-list li {\n  width: 45%;\n  font-size: 0.9em;\n  color: #333;\n}\n\n/* Button */\n.website-design-button {\n  background-color: #00c853;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  font-size: 1em;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 20px;\n  transition: background-color 0.3s ease;\n}\n\n.website-design-button:hover {\n  background-color: #009624;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .website-design-container {\n    flex-direction: column; /* Stack items vertically */\n    align-items: center; /* Center items in the column */\n    padding: 20px; /* Adjust padding for smaller screens */\n    gap: 10px; /* Reduce gap between sections */\n  }\n\n  .website-design-image {\n    width: 88%; /* Full width image */\n    height:20%;\n    padding-top:80px; /* Remove extra margin */\n  }\n\n  .website-design-text {\n    width: 100%; /* Full width content */\n    text-align: left; /* Center-align text for better mobile readability */\n    margin-top: -10px; /* Add spacing between image and text */\n    margin-bottom: 20px;\n  }\n\n  .website-design-text h1 {\n    font-size: 2.0em; /* Adjust font size */\n  }\n\n  .website-design-text h2 {\n    font-size: 1em; /* Adjust font size */\n  }\n\n  .website-design-text p {\n    font-size: 0.9em; /* Adjust font size */\n  }\n\n  .website-design-button {\n    width: 100%; /* Full width button */\n  }\n}\n\n\n\n\n@media (min-width: 1380px) and (max-width: 1919px) {\n  .website-design-container {\n    max-width: 1400px;\n    margin: 0 auto;\n    padding: 80px; /* Reduced padding for smaller screens */\n    padding-top:150px;\n  }\n\n  .website-design-image {\n    width: 32%; /* Adjusted image size */\n    margin-top: 20px;\n  }\n\n  .website-design-text {\n    width: 62%; /* Adjusted content width */\n    margin-top: -100px;\n  }\n\n  .website-design-text h1 {\n    font-size: 2em; /* Medium heading size */\n  }\n\n  .website-design-text h2 {\n    font-size: 1rem;\n  }\n\n  .website-design-text p {\n    font-size: 1rem;\n  }\n\n  .services-list li {\n    width: 45%; /* Adjust spacing */\n  }\n\n  .website-design-button {\n    font-size: 1em; /* Default button size */\n    padding: 10px 20px;\n  }\n}\n/* Styles for Large Screens (1920px and Above) */\n@media (min-width: 1920px) {\n  .website-design-container {\n    max-width: 1600px;\n    margin: 0 auto; /* Center the container */\n    padding: 100px; /* Increased padding for larger screens */\n  }\n\n  .website-design-image {\n    width: 40%; /* Slightly larger image */\n    margin-top: 0; /* Adjust top margin */\n  }\n\n  .website-design-text {\n    width: 55%; /* Adjusted content width */\n    margin-top: 0; /* Align content vertically */\n  }\n\n  .website-design-text h1 {\n    font-size: 2.5em; /* Larger heading for desktops */\n  }\n\n  .website-design-text h2 {\n    font-size: 1.2em; /* Larger subheading */\n  }\n\n  .website-design-text p {\n    font-size: 1.1rem; /* Larger paragraph text */\n  }\n\n  .services-list li {\n    width: 42%; /* Adjust width for better spacing */\n  }\n\n  .website-design-button {\n    font-size: 1.1em; /* Larger button text */\n    padding: 15px 25px; /* Bigger button for emphasis */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
